import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function BoostSection() {
    const navigate = useNavigate();
    return (
        <>
            <section className="boost-section" id="boost-section">
                <div className="row ">
                    <div className="container">
                        <div className="boost-wrap wow fadeInLeft">
                            <div className="title wow zoomIn">
                                <h2>Boost Non-Dues Revenue <span className="red"> with Snapshot Videos!</span> </h2>
                            </div>
                            <p className="wow fadeInRight">Turn Snapshot Videos into a revenue generator by offering sponsorship opportunities—adding value for your organization while keeping your members informed.</p>
                            {/* <a onClick={() => { navigate('/order-video') }} className="btn order-btn wow fadeInLeft">Order Now</a> */}
                            <a href="#lets-discuss-section" className="btn order-btn wow fadeInLeft">Schedule a Call</a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
